require('./Content.less');



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Content/Content.js
// module id = 141
// module chunks = 0